export const defaultState = {
  values: {},
  errors: {}
}

type State = typeof defaultState

export function reducer(state: State, action: { type: string, payload: any }) {
  switch(action.type) {
    case 'value': return {
      values: { ...state.values, [action.payload.key]: action.payload.value },
      errors: { ...state.errors, [action.payload.key]: null }
    }
    case 'error': return {
      values: state.values,
      errors: { ...state.errors, [action.payload.key]: action.payload.value}
    }
    case 'values': return {
      values: action.payload,
      errors: state.errors
    }
    case 'errors': return {
      values: state.values,
      errors: action.payload
    }
    default:
      return state
  }
}

export function isEmptyErrors(errors: State['errors']) {
  return Object.values(errors).some(value => !!value)
}